// assets/quick-order-list.js

document.addEventListener('DOMContentLoaded', () => {
  // 1) Find the Quick-Order List wrapper
  const list = document.querySelector('quick-order-list');
  if (!list) return;

  // 2) Grab all the quantity inputs inside that list
  const inputs = Array.from(
    list.querySelectorAll('input.quantity-selector__value')
  );

  // 3) Initialize each input: blank value + placeholder “0”
  inputs.forEach(input => {
    if (input.disabled) return;
    input.value           = '';
    input.placeholder     = '0';
    input.setAttribute('data-old-quantity', 0);
  });

  // 4) Get your buttons & links
  const submitBtn   = document.querySelector('.js-open-mini-cart');
  const btnText     = submitBtn?.querySelector('.button-text');
  const priceSpan   = submitBtn?.querySelector('.quick-multibuy-submit-price');
  const clearAllBtn = list.querySelector('#clearAll');
  const skuEl       = document.querySelector('.product-meta__sku-number');


  // 5) Clear-All handler
  clearAllBtn?.addEventListener('click', e => {
    e.preventDefault();
    inputs.forEach(input => {
      if (!input.disabled) {
        input.value = '';
        input.setAttribute('data-old-quantity', 0);
      }
    });
    recalc();
  });

  // 6) Formatter helper
  function fmt(cents) {
  // 1a) If Shopify.formatMoney exists, use it with Shopify.money_format:
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }

  // 1b) Otherwise, force a fallback template that always has {{amount}}:
  //     (we use “€{{amount}}” here—adjust if your default should be “€{{amount_with_comma_separator}}”)
  const formatString = Shopify.money_format || '€{{amount}}';

  // 1c) Replace {{amount}} with “cents/100” to two decimals (e.g. “0.00” or “24.99”)
  return formatString.replace(/{{.*?}}/, (cents / 100).toFixed(2));
}

  // 7) Recalc function: subtotals, totals, button text, price, clear-all
  function recalc() {
    let totalQty = 0;
    let totalCost = 0; // in cents

    inputs.forEach(input => {
      const qty = parseInt(input.value, 10) || 0;
      totalQty += qty;

      const row   = input.closest('.variant-item');
      const price = parseInt(
        row.querySelector('.js-variant-item-price').dataset.itemPrice,
        10
      ) || 0;
      const sub = qty * price;

      // update that row’s subtotal
      const subEl = row.querySelector('.variant-item__subtotal');
      if (subEl) subEl.textContent = fmt(sub);

      totalCost += sub;
    });

    // Update the Add-to-Cart button
if (submitBtn) {
  submitBtn.disabled = totalQty === 0;

  if (btnText) {
    // Pull translations from window.__ (dynamic-translations.liquid)
    const {
      addToCartLabel,
      addSingleItemToCartTpl,
      addMultipleItemsToCartTpl
    } = window.__;

    let text;
    if (totalQty === 0) {
      text = addToCartLabel;
    } else if (totalQty === 1) {
      text = addSingleItemToCartTpl.replace('{{count}}', totalQty);
    } else {
      text = addMultipleItemsToCartTpl.replace('{{count}}', totalQty);
    }

    btnText.textContent = text;
  }

  if (priceSpan) {
    if (totalQty > 0) {
      priceSpan.classList.remove('hidden');
      priceSpan.textContent = '\u00A0-\u00A0' + fmt(totalCost);
    } else {
      priceSpan.classList.add('hidden');
      priceSpan.textContent = '';
    }
  }
}


    // Toggle Clear-All link visibility
    if (clearAllBtn) {
      clearAllBtn.classList.toggle('hidden', totalQty === 0);
    }
  }

  // 8) Wire up the + / – buttons
  list.querySelectorAll('button.quantity__button').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const input = btn
        .closest('.quantity-popover-container')
        .querySelector('input.quantity-selector__value');
      if (!input || input.disabled) return;

      let val = parseInt(input.value, 10);
      if (isNaN(val)) val = 0;
      if (btn.name === 'plus') {
        val++;
      } else {
        val = Math.max(0, val - 1);
      }
      input.value = val;

      // 1) Recalculate totals & button UI
      recalc();

      // 2) Update the SKU display just like on focus
      if (skuEl) {
        skuEl.textContent = input.dataset.variantSku;
      }
    });
  });


  // 9) Wire up manual typing & SKU switcher
  inputs.forEach(input => {
    if (input.disabled) return;

    const nav = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab'];

    // Block non-digit keystrokes
    input.addEventListener('keydown', e => {
      if (!e.key.match(/^[0-9]$/) && !nav.includes(e.key)) {
        e.preventDefault();
      }
    });

    // Strip non-digits on input, then recalc
    input.addEventListener('input', recalc);
    input.addEventListener('change', recalc);

    // On focus, update the SKU header
    input.addEventListener('focus', function() {
      const skuEl = document.querySelector('.product-meta__sku-number');
      const sku   = this.dataset.variantSku;
      if (skuEl && sku) skuEl.textContent = sku;
    });
  });

// 10) Bulk-add to cart on button click
submitBtn?.addEventListener('click', e => {
  e.preventDefault();

  // collect only lines with qty > 0, pulling ID from the <tr data-variant-id>
  const items = inputs
    .map(input => {
      // find the parent row and read its data-variant-id
      const row = input.closest('.variant-item');
      const id  = parseInt(row?.dataset.variantId, 10) || 0;
      const qty = parseInt(input.value,           10) || 0;
      return id > 0 && qty > 0
        ? { id, quantity: qty }
        : null;
    })
    .filter(Boolean);


  if (!items.length) return;

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ items })
  })
  .then(() => {
    // reset all inputs & recalc
    inputs.forEach(i => { if (!i.disabled) i.value = ''; });
    recalc();
    // open mini-cart
    document.querySelector('.header__cart-toggle')?.click();
  })
  .catch(console.error);
});



  // 11) Kick things off
  recalc();
});
